import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "../components/confirmationDialog/ConfirmationDialog";
import type { RewardResponse } from "../rewards/rewardsApi";
import { CardMediaImg } from "./CardImage";

interface Props {
  readonly value: RewardResponse;
}

const RewardCard: FC<Props> = ({ value }) => {
  const navigate = useNavigate();
  const [confirmationDialog, setConfirmationDialog] = useState<{
    content: string;
    onConfirm: () => Promise<void>;
  }>();
  return (
    <>
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          transition: "all 0.3s ease",
          height: "100%",
          borderRadius: 1, // <-- większe zaokrąglenie
          overflow: "hidden",
          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.08)",
          },
        }}
        data-testid="reward-card"
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CardMediaImg
            imageUrl={value?.image?.thumbnail?.url}
            height="200"
            alt={value.name}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(value.id)}
          />
        </Box>

        <CardContent sx={{ flexGrow: 1, p: 3, display: "flex", flexDirection: "column" }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: "bold",
              lineHeight: 1.3,
            }}
          >
            {value.name}
          </Typography>
          {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 3, flexGrow: 1 }}>
            {value?.image?.thumbnail?.url ? `Poczuj magię wiecznego miasta! W pakiecie przelot, 2 noce w 
            hotelu **** ze śniadaniem oraz bilet wstępu do Koloseum.` : "XD"}
          </Typography> */}

          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Chip
              icon={<EmojiEventsIcon sx={{ color: "#e6a800 !important" }} />}
              label={`${value.cost.toLocaleString()} pkt`}
              sx={{
                fontWeight: "bold",
                bgcolor: "rgba(230, 168, 0, 0.1)",
                color: "#b38200",
                border: "none",
              }}
            />
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate(value.id)}
              endIcon={<ArrowForwardIcon />}
              sx={{ fontWeight: "bold" }}
              data-testid="reward-details"
            >
              Szczegóły
            </Button>
          </Stack>
        </CardContent>
      </Card>
      <ConfirmationDialog
        open={!!confirmationDialog}
        title="Zakup nagrody"
        content={confirmationDialog?.content}
        onCancel={() => setConfirmationDialog(undefined)}
        onConfirm={confirmationDialog?.onConfirm}
      />
    </>
  );
};

export default RewardCard;
